import classNames from "classnames";
import {Suspense} from "react";
import {Helmet} from "react-helmet-async";
import {Link} from "react-router";

import CloudMonitoringSvg from "@/assets/images/cloud-monitoring.svg";
import StatusPageUpSvg from "@/assets/images/status-page-up.svg";
import Button from "@/components/button/Button.tsx";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {ContentHeaderButton} from "@/marketingPages/components/contentheaderbutton/ContentHeaderButton.tsx";
import {CTABlock} from "@/marketingPages/components/ctablock/CTABlock.tsx";
import {MarketingBanner} from "@/marketingPages/components/marketingbanner/MarketingBanner.tsx";
import {IsItDownFAQs} from "@/marketingPages/isitdown/components/isitdownfaqs/IsItDownFAQs.tsx";
import {IsItDownList} from "@/marketingPages/isitdown/components/isitdownlist/IsItDownList.tsx";
import {IsItDownReviews} from "@/marketingPages/isitdown/components/isitdownreviews/IsItDownReviews.tsx";
import {PublicProfilesRecentOutages} from "@/marketingPages/isitdown/components/recentoutages/PublicProfilesRecentOutages.tsx";

import styles from "./IsItDownPage.module.scss";

export const IsItDownPage = () => {
  return (
    <div>
      <Helmet>
        <title>Third Party Service, Outage & Incident Monitoring</title>
        <meta
          name="description"
          content="Our proprietary website monitoring technology lets you monitor uptime and downtime for Facebook, Twitter, Netflix, Snapchat, and hundreds of other websites."
        />
      </Helmet>
      <h1 className={classNames(styles.header, "marketingTextH2Bold pulse-color-gray-800 text-center")}>
        Monitoring thousands of services
        <br className="marketingHideOnMobile" /> from third-party providers
      </h1>
      <UpErrorBoundary>
        <IsItDownList />
      </UpErrorBoundary>
      <MarketingBanner
        icon={<img src={CloudMonitoringSvg} alt="Can't find the service you need to check?" />}
        text={
          <>
            Can't find the service you need to check?
            <div>
              <Link to={`/contact`} className="pulse-color-green-500">
                Contact us
              </Link>{" "}
              and we will add it!
            </div>
          </>
        }
        button={
          <Button
            variant="marketingPrimary"
            size="marketingLarge"
            as={Link}
            to="https://feedback.uptime.com/"
            target="_blank"
          >
            Request Service
          </Button>
        }
      />
      <div className={`${styles.recentOutages} d-flex flex-column align-items-center pulse-bg-gray-50`}>
        <div>
          <h2 className="marketingTextH2Bold text-center mb-3">Recent Cloud Service Outages and Incidents</h2>
          <div className="marketingTextBody">Follow recent outages and incidents reported below</div>
          <UpErrorBoundary>
            <Suspense fallback={<LoadingContainer />}>
              <PublicProfilesRecentOutages />
            </Suspense>
          </UpErrorBoundary>
        </div>
      </div>
      <MarketingBanner
        icon={<img src={StatusPageUpSvg} alt="Status Up image" />}
        text={<>Looking to track, alert and aggregate all of your cloud services in a single Status Page?</>}
        button={<ContentHeaderButton containerClass="flex-column" />}
      />
      <CTABlock
        title="Get notified about Cloud Service outages"
        subtitle="Stay updated with instant alerts for Third Party Cloud Service and downtime by signing up now!"
      />
      <IsItDownFAQs />
      <IsItDownReviews />
    </div>
  );
};
